// Page
export const START_PAGE = 'START_PAGE';
export const FILTERS_PAGE = 'FILTERS_PAGE';
export const PRODUCT_PAGE = 'PRODUCT_PAGE';
// sort
export const sortItems = {
    chaepAtFirst: 'Cheap at first',
    expensiveFirst: 'Expensive first',
    MoreInStock: 'More in stock',
    LessInStock: 'Less in stock'
};
